<template>
    <div class="full-height grey-back">
        <v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
		    <v-toolbar-title class="white--text">
		    	Batches
		    </v-toolbar-title>
		</v-toolbar>

        <div class="hasToolbar hasFooter">
            <template v-for="(batch, batchIndex) in batches">
                <v-card flat :key="batchIndex" :class="{'mb-2':batches.length - 1 != batchIndex}">
                    <v-card-text class="pb-2">
                        <v-layout row wrap>
                            <v-flex xs4 sm4 md4 mb-2 v-for="(field, fieldIndex) in $root.TransactionSettings.batchFields" :key="fieldIndex">
                                <div light-opacity-color>{{ field.title }}</div>
                                <div>{{ batch[field.id] }}</div>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="pb-1 pt-1">
                        <v-layout row wrap class="pt-1">
                            <v-flex center-align :class="[!batch.productId ? 'xs6 sm6 md6' : 'xs12 sm12 md12']">
                                <v-btn flat block color="primary" @click="fn_editBatch(batchIndex)">Edit</v-btn>
                            </v-flex>
                            <v-flex xs6 sm6 md6 center-align v-if="!batch.productId">
                                <v-btn flat block color="red" @click="batches.splice(batchIndex, 1)" style="border-left: 1px #ddd solid;">Remove</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-actions>
                </v-card>
                <!-- <v-divider v-if="batches.length - 1 != batchIndex"></v-divider> -->
            </template>

            <!-- <v-card flat class="mb-3" v-for="(batch, index) in batches" :key="index">
                <v-card-text class="pb-0">
                    <v-layout row wrap>
                        <v-flex xs4 sm4 md4 mb-3>
                            <div light-opacity-color>Batch No.</div>
                            <div>{{ batch.batchNumber }}</div>
                        </v-flex>
                        <v-flex xs4 sm4 md4 mb-3>
                            <div light-opacity-color>Size</div>
                            <div>{{ batch.batchSize }}</div>
                        </v-flex>
                        <v-flex xs4 sm4 md4 mb-3>
                            <div light-opacity-color>MRP</div>
                            <div>{{ batch.batchMRP }}</div>
                        </v-flex>
                        <v-flex xs4 sm4 md4 mb-3>
                            <div light-opacity-color>Mfg. Date</div>
                            <div v-if="batch.mfgDate">{{ batch.mfgDate | moment('DD-MMM-YYYY') }}</div>
                        </v-flex>
                        <v-flex xs4 sm4 md4 mb-3>
                            <div light-opacity-color>Exp. Date</div>
                            <div v-if="batch.expDate">{{ batch.expDate | moment('DD-MMM-YYYY') }}</div>
                        </v-flex>
                        <v-flex xs4 sm4 md4 mb-3>
                            <div light-opacity-color>Opening</div>
                            <div>{{ batch.opening ? batch.opening : 0  }}</div>
                        </v-flex>
                        <v-flex xs4 sm4 md4 mb-3>
                            <div light-opacity-color>Purchase Rate</div>
                            <div>{{ batch.purchaseRate }}</div>
                        </v-flex>
                        <v-flex xs4 sm4 md4 mb-3>
                            <div light-opacity-color>Serial Number</div>
                            <div>{{ batch.field1 }}</div>
                        </v-flex>
                        <v-flex xs4 sm4 md4 mb-3>
                            <div light-opacity-color>IMEI Number</div>
                            <div>{{ batch.field2 }}</div>
                        </v-flex>
                        <v-flex xs4 sm4 md4 mb-3>
                            <div light-opacity-color>Part Number</div>
                            <div>{{ batch.field3 }}</div>
                        </v-flex>
                        <v-flex xs4 sm4 md4 mb-3>
                            <div light-opacity-color>Model Number</div>
                            <div>{{ batch.field4 }}</div>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-card-actions class="pb-1">
                    <v-layout row wrap class="pt-1">
                        <v-flex xs6 sm6 md6 center-align>
                            <v-btn flat block color="primary" @click="fn_editBatch(index)">Edit</v-btn>
                        </v-flex>
                        <v-flex xs6 sm6 md6 center-align>
                            <v-btn flat color="red" @click="batches.splice(index, 1)">Remove</v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card> -->
        </div>

        <v-layout white-background row wrap style="position: fixed;bottom: 0;width: 100%;">
            <v-flex xs6 sm6 md6 center-align>
                <v-btn block flat style="height: 48px;" color="primary" @click="fn_openBatchDialog">Add Batch</v-btn>
            </v-flex>
            <v-flex xs6 sm6 md6 center-align>
                <v-btn block style="height: 48px;" color="primary" @click="fn_saveBatches">Save</v-btn>
            </v-flex>
        </v-layout>

        <dialog-batches ref="ref_dialogBatches" :openDatePicker="fn_openDatePicker"></dialog-batches>
        <dialog-datepicker ref="ref_dialogDatePicker" :selected="selectedDate" :updateDate="fn_updateDate"></dialog-datepicker>
    </div>
</template>

<script>
import dialogBatches from './dialog_form'
import dialogDatepicker from '../../../dialogs/dialog_datepicker'

export default{
    components:{
        'dialog-batches':dialogBatches,
        'dialog-datepicker':dialogDatepicker,
    },
    data(){
        return{
            batches:[],
            selectedDate:null,
            dateType:null,
            dialog_datepicker:false,
            batchFields:[]
            // batchFields:[
			//     {"id":"batchNumber", "title":"Batch Number", "status":true, "value":null, "orderNumber":1, "type":"string"},
			// 	{"id":"mfgDate", "title":"Mfg Date", "status":true, "value":null, "orderNumber":2, "type":"date"},
			// 	{"id":"expDate", "title":"Exp Date", "status":true, "value":null, "orderNumber":3, "type":"date"},
			// 	{"id":"opening", "title":"Opening", "status":true, "value":null, "orderNumber":4, "type":"number"},
			// 	{"id":"size", "title":"Size", "status":true, "value":null, "orderNumber":5, "type":"string"},
			// 	{"id":"mrp", "title":"MRP", "status":false, "value":null, "orderNumber":6, "type":"number"},
			// 	{"id":"purchaseRate", "title":"Purchase Rate", "status":false, "value":null, "orderNumber":7, "type":"number"},
			// 	{"id":"field1", "title":"Serial Number", "status":false, "value":null, "orderNumber":8, "type":"string"}, //(serialNumber)
			// 	{"id":"field2", "title":"IMEI Number", "status":false, "value":null, "orderNumber":9, "type":"string"}, //(imeiNumber)
			// 	{"id":"field3", "title":"Part Number", "status":false, "value":null, "orderNumber":10, "type":"string"}, //(partNumber)
			// 	{"id":"field4", "title":"Model Number", "status":false, "value":null, "orderNumber":11, "type":"string"} //(modelNumber)
			// ]
        }
    },
    methods:{
        fn_openBatchDialog: function(){
            this.$refs['ref_dialogBatches'].openDialogWeb();
        },
        fn_editBatch: function(index){
            this.$refs['ref_dialogBatches'].dataObj = JSON.parse(JSON.stringify(this.batches[index]));
            for(let i=0; i<this.batchFields.length; i++){
                this.batchFields[i].value = this.batches[index][this.batchFields[i].id];
            }
            this.fn_openBatchDialog();
        },
        fn_saveBatches: function(){
            if(this.batches.length){
                let newBatches = this.batches.filter(item=>{return item.isNew === true || item.isNew === false});
                localStorage.setItem('batch_data', JSON.stringify(newBatches));
                // localStorage.setItem('batch_data', JSON.stringify(this.batches));
                this.fn_goBack();
                // if(this.$route.query.post){
                //     this.fn_postBatches();
                // }
                // else{
                //     this.fn_goBack();
                // }
            }
            else{
                this.showToast("Please add batch");
            }
        },
        fn_postBatches: function(){
            let self = this;
            let postObj = {};
            postObj.productId = this.$route.query.pid;
            postObj.productBatchList = this.batches;
            this.postData('PostProductBatchList', postObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.fn_goBack();  
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },
        fn_openDatePicker: function (type, date) {
            let self = this;
            this.dateType = type;
            let dateObj = date ? new Date(date) : new Date();
            this.$refs['ref_dialogDatePicker'].selectedDate = dateObj.getFullYear()+'-'+("0" + (dateObj.getMonth()+1)).slice(-2)+'-'+("0" + dateObj.getDate()).slice(-2);
            setTimeout(function () {
                self.dialog_datepicker = true;
            })
        },
        fn_updateDate: function (value) {
            // if(this.dateType=="mfgDate"){
            //     this.$refs['ref_dialogBatches'].dataObj.mfgDate = value;
            // }
            // else if(this.dateType=="expDate"){
            //     this.$refs['ref_dialogBatches'].dataObj.expDate = value;
            // }
            let fIndex = this.batchFields.findIndex(item=>{return item.id === this.dateType});
            this.batchFields[fIndex].value = value;
            this.dialog_datepicker = false;
        },
        fn_getBatches: function(){
            let self = this;
            this.getData('GetProductBatchByProductId', this.$route.query.pid, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.batches = JSON.parse(response);

                        if(localStorage.getItem('batch_data')){
                            self.batches.concatenate(JSON.parse(localStorage.getItem('batch_data')));
                            localStorage.removeItem('batch_data');
                        }

                        if(self.$route.query.dialog){
                            self.fn_openBatchDialog();
                        }
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },
        fn_goBack: function(){
            this.$router.go(-1);
        }
    },
    mounted: function(){
        window.js_globals.fn_onBackPress = this.fn_goBack;
        if(this.$route.query.pid && !this.$route.query.new){
            this.fn_getBatches();
        }
        else if(this.$route.query.dialog){
            this.fn_openBatchDialog();
        }
        else if(localStorage.getItem('batch_data')){
            this.batches = JSON.parse(localStorage.getItem('batch_data'));
            localStorage.removeItem('batch_data');
        }

        if(this.$root.TransactionSettings.batchFields && this.$root.TransactionSettings.batchFields.length){
            for(let i=0; i<this.$root.TransactionSettings.batchFields.length; i++){
                if(this.$root.TransactionSettings.batchFields[i].status){
                    let obj = JSON.parse(JSON.stringify(this.$root.TransactionSettings.batchFields[i]));
                    obj.value = null;
                    this.batchFields.push(obj);
                }
            }
        }
    },
    beforeRouteLeave (to, from, next) {
        if(this.$refs['ref_dialogBatches'] && this.$refs['ref_dialogBatches'].dialog_batches && (!this.$route.query.dialog || this.$route.query.dialog && this.batches.length)){
            this.$refs['ref_dialogBatches'].closeDialogWeb();
            next(false);
        }
        else{
            next();
        }
    }
}

</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/product_batches/batches.vue